import styled from "@emotion/styled"
import ContainerWrapper from "pazChargeComponents/general/ContainerWrapper"
import { ImageContainer, NewText, TitleWithLine, extractProperty } from "ui"
import { checkIfStartsWithParagraph } from "utils"
import { getNonUmbracoURL } from "utils/utils"

const StyledWrapper = styled.div`
    padding-top: 60px;
    padding-bottom: 60px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding-top: 80px;
    padding-bottom: 80px;
    display: grid;
    gap: 20px;
    align-items: center;
    grid-template-columns: 1fr 1fr;
  }
`
const StyledTitleAndText = styled.div`
    p {
    line-height: 20px;
    margin-top: 12px;
    margin-bottom: 12px;
    }
  ${(props) => props.theme.breakpoints.up("md")} {
    flex: 1;
    justify-content: center;
    p {
    line-height: 20px;
    margin-top: 10px;
    // margin-bottom: 0px;
    }
  }
`
const StyledContainerWrapper = styled.div`
    background: rgba(21, 62, 105, 0.1);

`



function ImageWithTextHomeCharge({ data }: { data: any }) {

    const headline = extractProperty(data, "headline")
    const body = extractProperty(data, "body")
    const image = extractProperty(data, "image")
    const mobileImage = extractProperty(data, "mobileImage")
    return (
        <StyledContainerWrapper>
            <ContainerWrapper>
                <StyledWrapper>
                    <StyledTitleAndText>
                        {headline && (
                            <TitleWithLine
                                title={headline}
                                titleColor="black"
                                titleFontSize={34}
                                mobileTitleFontSize={24}
                                component={"h2"}
                                lineMarginTop={20}
                                noMobileMargin
                            />
                        )}
                        {body && (
                            <NewText
                                component={checkIfStartsWithParagraph(body) ? "div" : "p"}
                                desktopFontSize={18}
                                desktopFontWeight={400}
                                desktopLineHeight={"30px"}
                                mobileFontSize={18}
                                mobileLineHeight={"28px"}
                                smallDesktopFontSize={14}
                                smallDesktopLineHeight="14px"
                                dangerouslySetInnerHTML={{ __html: body }}
                            />
                        )}
                    </StyledTitleAndText>
                    <ImageContainer
                        desktopUrl={getNonUmbracoURL(image)}
                        mobileUrl={getNonUmbracoURL(mobileImage)}
                        height={454}
                        style={{ marginTop: 10, borderRadius: 10 }}
                    />
                </StyledWrapper>
            </ContainerWrapper>
        </StyledContainerWrapper>
    )
}

export default ImageWithTextHomeCharge
